import debounce from 'lodash/debounce';
import { useCallback } from 'react';
/**
 * N.B. If you have a typed argument(s) function inside debounce callback
 * always provide outer function description and type cast,
 * type cast alone will cause runtime errors!
 */
export const useDebouncedCallback = (callback, delay = 0, deps = [], options
// eslint-disable-next-line react-hooks/exhaustive-deps
) => useCallback(debounce(callback, delay, options), [...deps, delay, options]);
//# sourceMappingURL=useDebouncedCallback.js.map